import { render } from "./Aftercare2.vue?vue&type=template&id=a29eb346"
import script from "./Aftercare2.vue?vue&type=script&lang=js"
export * from "./Aftercare2.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_1ea34a31/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__